import React, { Component } from 'react';
import { Badge, Button, Input, Table, Form, FormGroup, Label, FormFeedback, Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';
import moment from 'moment';
import { connect } from 'react-redux';

class EventScheduler extends Component {
    //This is my most cluttered and complicated component I've ever created. No, I won't apologize.
    constructor(props) {
        super(props);
        this.state = {
            //instructors: [],
            //instructors: this.props.eventData.instr,
            //scheduleRecords: [],
            //scheduleRecords: this.props.eventData.schedrecords,
            returnable: this.props.reduxData.userInfo,
            //actions: [],
            //actions: this.props.eventData.schedactions,
            //availableInstructors: [],
            //availableInstructors: this.props.eventData.instroption,
            availableDays: [],
            availableBuildings: [],
            availableRooms1: [{ "name": "No Preference", "code": "ANY" }],//By defining this up here, we can keep the iterative construction of the dropdown without having to worry about default values
            availableRooms2: [{ "name": "No Preference", "code": "ANY" }],
            timeError: false,
            dateError: false,
            dayError: false,
            addInstructorError: false,
            testEventPK: this.props.eventpk,
            startTime: "",
            endTime: "",
            startDate: "",
            endDate: "",
            //notes: "",
            //notes: this.props.eventData.schednote,
            activeDepartment: "",
            isOnlineHybrid: false,
            errorModalStatus: false,
            errorMessage: "",
            //currentTermDates: { "startDate": "19551105", "endDate": "20121221" }, //These dates definitely have no significance whatsoever.
            //currentTermDates: this.props.eventData.termbrackets,
            currentTerm: [],
            //eventDateExempt: false,
            //eventDateExempt: this.props.eventData.isexempt,
            editLockModal: false,
            room1select: "ANY",
            room2select: "ANY",
            instructors: this.props.eventData[0].instr,
            availableInstructors: this.props.eventData[0].instroption,
            actions: this.props.eventData[0].actions,
            notes: this.props.eventData[0].note,
            scheduleRecords: this.props.eventData[0].schedrecord,
            currentTermDates: this.props.eventData[0].brackets,
            eventDateExempt: this.props.eventData[0].isexempt
        }
        this.getEventData();
        this.removeInstructor = this.removeInstructor.bind(this);
        this.removeRecord = this.removeRecord.bind(this);
        this.getRooms = this.getRooms.bind(this);
    }

    async getEventData() { //This function's primary role is to be a single place where all of the different data fetches can be held
                            //Basically every one of the functions listed here is exactly the same, with slight exceptions in the ones which have at their end calls to other functions that are
                            //exactly the same.
        var dept = this.props.reduxData.userInfo.level.pk;
        dept = dept.substring(0, dept.indexOf('-') - 1);
        this.setState({
            activeDepartment: dept
        })
    }

    //async getInstructors() { //This function retrieves the instructors that are associated with this event
    //    //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
    //    let bearerVAR = "Bearer " + this.props.reduxData.apiKey
    //    this.props.updateFetchTime();
    //    let toSend = {
    //        userLevel: this.props.reduxData.userInfo.level.pk,
    //        eventpk: this.props.eventpk //So it turns out you can't name this 'event' since that's a reserved word in C# and the model class won't let you name a property that
    //    }
    //    const response = await fetch('EventInstructors', {
    //        method: 'POST',
    //        headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
    //        body: JSON.stringify(toSend)
    //    });
    //    const data = await response.json();
    //    //localStorage.setItem("lastFetch", moment());
    //    this.setState({
    //        instructors: data
    //    })
    //    //this.getAvailableInstructors();
    //}

    //async getAvailableInstructors() { //This function populates the dropdown for instructors that can teach this class. The procedure only gets instructors that have taught before, but that's a 
    //                                    //concern for if/when someone brings it up
    //    let toSend = {
    //        userLevel: this.props.reduxData.userInfo.level.pk,
    //        eventpk: this.props.eventpk 
    //    }
    //    //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
    //    let bearerVAR = "Bearer " + this.props.reduxData.apiKey
    //    this.props.updateFetchTime();
    //    const response = await fetch('InstructorOptions', {
    //        method: 'POST',
    //        headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
    //        body: JSON.stringify(toSend)
    //    });
    //    const data = await response.json();
    //    //localStorage.setItem("lastFetch", moment());
    //    this.setState({
    //        availableInstructors: data
    //    })
    //}

    //async getScheduleRecords() {//This function gets the previously defined schedules for this event
    //    //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
    //    let bearerVAR = "Bearer " + this.props.reduxData.apiKey
    //    this.props.updateFetchTime();
    //    let toSend = {
    //        userLevel: this.props.reduxData.userInfo.level.pk,
    //        eventpk: this.props.eventpk
    //    }
    //    const response = await fetch('EventSchedRecords', {
    //        method: 'POST',
    //        headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
    //        body: JSON.stringify(toSend)
    //    });
    //    const data = await response.json();
    //    //localStorage.setItem("lastFetch", moment());
    //    this.setState({
    //        scheduleRecords: data
    //    })
    //
    //}

    //async getNotes() {//This function gets the note value for the listed event
    //    //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
    //    let bearerVAR = "Bearer " + this.props.reduxData.apiKey
    //    this.props.updateFetchTime();
    //    let toSend = {
    //        userLevel: this.props.reduxData.userInfo.level.pk,
    //        eventpk: this.props.eventpk
    //    }
    //    const response = await fetch('EventSchedNotes', {
    //        method: 'POST',
    //        headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
    //        body: JSON.stringify(toSend)
    //    });
    //    const data = await response.json();
    //    //localStorage.setItem("lastFetch", moment());
    //    this.setState({
    //        notes: data
    //    })
    //}

    //async getAvailableActions() {//This function gets what actions can be taken on this event to populate the actions dropdown with
    //    //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
    //    let bearerVAR = "Bearer " + this.props.reduxData.apiKey
    //    this.props.updateFetchTime();
    //    let toSend = {
    //        userLevel: this.props.reduxData.userInfo.level.pk,
    //        eventstatus: this.props.eventstatus
    //    }
    //    const response = await fetch('GetActions', {
    //        method: 'POST',
    //        headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
    //        body: JSON.stringify(toSend)
    //    });
    //    const data = await response.json();
    //    //localStorage.setItem("lastFetch", moment());
    //    this.setState({
    //        actions: data
    //    })
    //}

    //async getTermDates() {//This function determines what the beginning and end dates are for the term we're working in (as defined by the term this event is listed in the database for)
    //    //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
    //    let bearerVAR = "Bearer " + this.props.reduxData.apiKey
    //    this.props.updateFetchTime();
    //    let toSend = {
    //        userLevel: this.props.reduxData.userInfo.level.pk,
    //        term: this.props.eventpk
    //    }
    //    const response =  await fetch('FindTermBrackets', {
    //        method: 'POST',
    //        headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
    //        body: JSON.stringify(toSend)
    //    });
    //    const data = await response.json();
    //    //localStorage.setItem("lastFetch", moment());
    //    this.setState({
    //        currentTermDates: data
    //    })
    //}

    //async isEventDateExempt() { //If this event is a LEAD or EDUC 500 or 600 level class, it's exempt from the date restrictions of the term's beginning and end dates
    //    //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
    //    let bearerVAR = "Bearer " + this.props.reduxData.apiKey
    //    this.props.updateFetchTime();
    //    let toSend = {
    //        userLevel: this.props.reduxData.userInfo.level.pk,
    //        eventpk: this.props.eventpk
    //    }
    //    const response = await fetch('CheckEventDateExempt', {
    //        method: 'POST',
    //        headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
    //        body: JSON.stringify(toSend)
    //    });
    //    const data = await response.json();
    //    //localStorage.setItem("lastFetch", moment());
    //    this.setState({
    //        eventDateExempt: this.props.eventData[0].isexempt
    //    })
    //}

    componentDidMount() {
        //console.log("event data prop: ", this.props.eventData)
        this.setState({
            instructors: this.props.eventData[0].instr,
            availableInstructors: this.props.eventData[0].instroption,
            actions: this.props.eventData[0].actions,
            notes: this.props.eventData[0].note,
            scheduleRecords: this.props.eventData[0].schedrecord,
            currentTermDates: this.props.eventData[0].brackets,
            eventDateExempt: this.props.eventData[0].isexempt
        })
    }

    //reevaluate() {
    //    this.getAvailableActions();
    //}

    async getRooms(input1, input2) {//Function to retrieve the rooms based on the building selected (input2) and then associate it with the proper dropdown (input1)
        input2.preventDefault();
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            buildCode: input2.target.value
        }
        const response = await fetch('AcadBuildings', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        if (input1 == "1") {
            this.setState({
                availableRooms1: data,
                room1select: "ANY"
            })
        }
        else if (input1 == "2") {
            this.setState({
                availableRooms2: data,
                room2select: "ANY"
            })
        }
    }

    async addInstructor(input) {//Adding an instructor to a section
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let pcidList = [];
        this.state.instructors.forEach((data) => {//Retrieving a list of current instructors that are already associated with this event
            pcidList.push(data.pcid)
        })
        if (pcidList != "" && input.target.value == "P000026818") {
            return; //If we have instructors here and the user is trying to add the Hood Faculty placeholder, we shouldn't let them. Get out of there.
        }
        else if (pcidList == "P000026818") {
            this.removeInstructor("P000026818"); //If the user is trying to add an actual instructor and we have the Hood Faculty placeholder here already, remove the placeholder before adding the instructor
        }
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            instructor: input.target.value,
            eventpk: this.props.eventpk
        }
        const response = await fetch('AddInstructorScheduling', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            addInstructorError: !data
        })
        this.props.schedCallback(this.props.eventpk);
    }

    async addScheduleRecord(e) {//This function adds a new schedule record based on what the user specifies. This is a big one.
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        this.setState({
            dayError: false,
            timeError: false,
            dateError: false
        })
        let errorsOccurred = 0;//This keeps track of how many illegal actions this user has taken
        let errorMessage = "";//This will be the full string of the error message, concatenated on itself every time something needs to be said
        e.preventDefault();
        const dataInput = new FormData(e.target);
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            eventpk: this.props.eventpk,
            days: dataInput.get('days'),
            starttime: dataInput.get('starttime'),
            endtime: dataInput.get('endtime'),
            startdate: dataInput.get('startdate'),
            enddate: dataInput.get('enddate'),
            building1: dataInput.get('building1'),
            room1: dataInput.get('room1'),
            building2: dataInput.get('building2'),
            room2: dataInput.get('room2')
        }
        let parsedStartDate = toSend.startdate.replaceAll("-", "");//Date format is always weird. Everyone tries to standardize the way it looks and everyone standardizes it differently.
        let parsedEndDate = toSend.enddate.replaceAll("-", "");
        if ((toSend.starttime >= toSend.endtime || toSend.startdate > toSend.enddate) && toSend.starttime != "" && toSend.endtime != "") {
            //This check catches when values have been entered for the start and end time values, and if the user is attempting to create a time paradox by ending a class before it starts
            //We don't need to check and verify that the dates have been filled in because there's another check for that later.
            if (toSend.starttime >= toSend.endtime) {//This error will be added to the error string when the time paradox is based on the class beginning and end times
                errorsOccurred = errorsOccurred + 1;
                errorMessage = errorMessage + "You are trying to add a schedule that starts after it ends.\n";
                this.setState({//Future note: In each of these, I have this.setState({}) calls which aren't really being used. We should get rid of these for when we have time to improve this code.
                    timeError: true,
                    errorMessage: this.state.errorMessage + "You are trying to add a schedule that starts after it ends.\n"
                })
            }
            if (toSend.startdate > toSend.enddate) {//This error message will be added when the time paradox is based on the date beginning and end times.
                errorsOccurred = errorsOccurred + 1;
                errorMessage = errorMessage + "You are trying to start a class after it has ended.\n";
                this.setState({
                    dateError: true,
                    errorMessage: this.state.errorMessage + "You are trying to start a class after it has ended.\n"
                })
                
            }
        }
        if (toSend.days == "" || toSend.days == null) {//This check catches when the user forgets to enter a day pattern into their schedule. You can't have a schedule that meets on no days,
                                                        //else why bother making this schedule at all? That's what the Delete action is for.
            errorsOccurred = errorsOccurred + 1;
            errorMessage = errorMessage + "You need to specify what days of the week this schedule is for. \n";
            this.setState({
                dayError: true,
                errorMessage: this.state.errroMessage + "You need to specify what days of the week this schedule is for. \n"
            })
        }
        if (toSend.startdate == "" || toSend.enddate == "") {//This check catches when the dates are blank. This will be extremely hard for the user to pull off, since these form fields
                                                                //auto populate and to my knowledge don't have a mechanism to remove it. A tech-savvy user could get around that, but the 
                                                                //methods would likely bypass this check as well. Regardless, it's something to control against so it's recorded here.
            errorsOccurred = errorsOccurred + 1;
            errorMessage = errorMessage + "You are attempting to add a schedule without specifying when your class begins and ends. \n";
            this.setState({
                dateError: true,
                errorMessage: this.state.errorMessage + "You are attempting to add a schedule without specifying when your class begins and ends. \n"
            })
        }
        if ((parsedStartDate < this.state.currentTermDates.startDate || parsedEndDate > this.state.currentTermDates.endDate) && this.state.eventDateExempt == false) {
            //This check catches when a user attempts to enter start and end dates before or after the start or end dates of the term itself (respectively) for a class that isn't exempted.
            //500 and 600 level EDUC and LEAD classes need to be able to add schedules outside of these dates
            errorsOccurred = errorsOccurred + 1;
            errorMessage = errorMessage + "You are attempting to add a schedule outside of this term's start and end dates. \n";
            this.setState({
                dateError: true
            })
        }
        if ((toSend.days == 'ZA41' || toSend.days == 'ZA43' || toSend.days == 'ZB41' || toSend.days == 'ZB43')
            && ((toSend.building1 == 'ONLINE' && toSend.room1 == 'ANY')
                ||(toSend.building1 == 'ONLINE' && toSend.room1 == 'ASYNCH' && (toSend.starttime != '00:01' || toSend.endtime != '00:02'))
                || toSend.building1 != 'ONLINE'
            //|| (toSend.building1 == 'ONLINE' && toSend.room1 == 'SYNCHR')
        )
        )
        {
            errorsOccurred = errorsOccurred + 1;
            errorMessage = errorMessage + "You need to have a specific structure for this schedule. An Asynchronous schedule must specify Online and Asynchronous for Building and Room respectively, and run from 12:01 AM to 12:02 AM. An online synchronous schedule must specify meeting days. Synchronous or asynchronous must be selected.\n"
        }
        if (errorsOccurred > 0) {//If any of the above checks were tripped, errorsOccurred will be incremented. If there are any errors, the schedule can't be loaded. So if the error count is above zero,
                                    //we can't save this schedule and we need to activate the modal to tell the user what they did wrong.
            this.setState({
                errorModalStatus: true,
                errorMessage: errorMessage
            })
        }
        if (errorsOccurred == 0) {//If there are no errors, we can go ahead with executing the controller that will insert this schedule into the database
            const response = await fetch('AddSchedRecord', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
                body: JSON.stringify(toSend)
            });
            const data = await response.json();
            //localStorage.setItem("lastFetch", moment());
            localStorage.setItem("lastFetch", moment());
            //this.getScheduleRecords();//Now that the schedule is added, we will need to get the schedules again to reflect what was just added
            this.props.schedCallback(this.props.eventpk);
        }
    }

    async removeInstructor(input) {//This function removes an instructor from this event
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            instructor: input,
            eventpk: this.props.eventpk
        }
        const response = await fetch('RemoveInstructorSched', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.props.schedCallback(this.props.eventpk);
    }   

    async removeRecord(input) {//This function removes a schedule from this event
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            pk: input
        }
        const response = await fetch('DeleteSched', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        //this.getScheduleRecords();
        this.props.schedCallback(this.props.eventpk);
    }

    async actionSelect(e, eventpk) {//This function handles an action being taken for this event
        let numberOfErrors = 0;//Like adding a schedule, this will require some error checking 
        let errorMessages = "";
        e.preventDefault();
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        if ((this.state.instructors == [".", ","] || this.state.instructors == [] || this.state.instructors == null || this.state.instructors == "") && e.target.value == "Submit") {
            //This check catches when a user attmepts to submit an event without instructors. There are a number of different conditions for this to be detected as having no instructors,
            //largely because to this day I'm still not sure which data type this.state.instructors will be represented as when empty. Better to include all of them.
            numberOfErrors = numberOfErrors + 1;
            errorMessages = errorMessages + "You need to assign an instructor to this course before you can submit it.\n";
        }
        if ((this.state.scheduleRecords == "" || this.state.scheduleRecords == null) && e.target.value == "Submit") {
            //This check fires when a user attempts to submit an event without any schedules associated with it
            numberOfErrors = numberOfErrors + 1;
            errorMessages = errorMessages + "You need to add at least one schedule to this course before you can submit it.\n";
        }
        if (this.state.scheduleRecords.filter(filter => {return filter.days == "HYBRID" }).length > 0
                && this.state.scheduleRecords.filter(f => { return f.days != 'ONLINE' && f.days != 'HYBRID' }).length == 0) {
            numberOfErrors = numberOfErrors + 1;
            errorMessages = errorMessages + "When submitting a hybrid class, you need to have one HYBRID schedule and one traditional schedule with a day not ONLINE or HYBRID.\n"
        }
        if (e.target.value == "UnDelete" && this.props.editable == false) { return; }
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            action: e.target.value,
            targets: eventpk
        }
        if (numberOfErrors > 0) {
            this.setState({
                errorMessage: errorMessages,
                errorModalStatus: true
            })
        }
        if (numberOfErrors == 0) {
            //There's a number of things we have to do here to fully reconfigure this event for the new status. The first is to actually have the new status be applied to the event.
            const response = await fetch('Action', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
                body: JSON.stringify(toSend)
            });
            const data = await response.json();
            //localStorage.setItem("lastFetch", moment());
            if (data.output != "true" && data.output != "false") {
                this.setState({
                    editLockModal: true
                    })
            }
            //Now that the event has its new status, we need to update the page information to reflect it. That means disabling the ability to edit for those who aren't Registrar, and
            //changing the status badge on the accordion header. However, that badge exists in the secSchedScheduling component while the action is taking place in hte eventScheduler
            //component, and callback functions have difficult times with actually executing parent component code from the child. So, we'll just do it live.
            //The first step is to get the data that the filter in secSchedScheduling gets in here
            let activeFilter = this.props.activeFilter;
            let toSend2 = {
                userLevel: activeFilter.userLevel,
                sortby: activeFilter.sortby,
                term: activeFilter.term,
                department: activeFilter.department,
                status: activeFilter.status
            }
            const response2 = await fetch('Filter', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
                body: JSON.stringify(toSend2)
            });
            const data2 = await response2.json();
            //After that, we can pass that data back to secSchedScheduling in the callback function, and that component can update the accordion from there.
            this.props.actionRerender(data2);
            this.props.schedCallback(this.props.eventpk);
        }
    }

    //async findIfDoneProp(level, term) {//This little chunk of madness is to determine whether we're allowed to finalize the term.It's in here because trying to put this in secSchedScheduling was fun.
    //    let toSend = {
    //        userLevel: level,
    //        currentTermSPID: term
    //    }
    //    const response = await fetch('FinalizeLegal', {
    //        method: 'POST',
    //        headers: { 'Content-Type': 'application/json' },
    //        body: JSON.stringify(toSend)
    //    });
    //    const data = await response.json();
    //    if (data.finalizeflag == "true") {
    //        this.props.refreshFinal(true);
    //    }
    //    else { this.props.refreshFinal(false) }
    //}

    //async propActionSelect(e, eventpk) {//We can probably get rid of this
    //    let numberOfErrors = 0;
    //    let errorMessages = "";
    //    if ((this.state.instructors == [".", ","] || this.state.instructors == [] || this.state.instructors == null || this.state.instructors == "") && e == "Submit") {
    //        numberOfErrors = numberOfErrors + 1;
    //        errorMessages = errorMessages + "You need to assign an instructor to this course before you can submit it.\n";
    //    }
    //    if ((this.state.scheduleRecords == "" || this.state.scheduleRecords == null) && e == "Submit") {
    //        numberOfErrors = numberOfErrors + 1;
    //        errorMessages = errorMessages + "You need to add at least one schedule to this course before you can submit it.\n";
    //    }
    //    let toSend = {
    //        userLevel: this.props.userData.level,
    //        action: e,
    //        targets: eventpk
    //    }
    //    if (numberOfErrors > 0) {
    //        this.setState({
    //            errorMessage: errorMessages,
    //            errorModalStatus: true
    //        })
    //    }
    //    if (numberOfErrors == 0) {
    //        const response = await fetch('Action', {
    //            method: 'POST',
    //            headers: { 'Content-Type': 'application/json' },
    //            body: JSON.stringify(toSend)
    //        });
    //        const data = await response.json();

    //        let activeFilter = this.props.activeFilter;
    //        let toSend2 = {
    //            userLevel: activeFilter.userLevel,
    //            sortby: activeFilter.sortby,
    //            term: activeFilter.term,
    //            department: activeFilter.department,
    //            status: activeFilter.status
    //        }
    //        const response2 = await fetch('Filter', {
    //            method: 'POST',
    //            headers: { 'Content-Type': 'application/json' },
    //            body: JSON.stringify(toSend2)
    //        });
    //        const data2 = await response2.json();
    //        this.props.actionRerender(data2);
    //        this.getAvailableActions();
    //        this.getNotes();
    //    }
    //}

    checkTimeError(e, type) {//This function will check to see if there is a time paradox about to occur on blur for the time and date fields of the schedule form.
                                //This way, the user will be alerted if they're attempting to create an error instead of needing to wait after they've already made an error to know
        if (type == "starttime") {//The type parameter identifies which of the four form inputs was just selected
            this.setState({//The first thing we do with it is to save it in its relevant state value, so that it can be compared in later iterations of this function
                startTime: e.target.value
            })
            if (this.state.endTime && e.target.value > this.state.endTime) {//The time values are being compared against each other. We need to determine whether a time paradox was just set up.
                                                                            //The other time value must have already been selected, and its value needs to be less than the start time for that setup.
                                                                            //An end time value less than a start time value is a time that is before the start time, which isn't allowed.
                this.setState({
                    timeError: true
                })
            }
            else {
                this.setState({
                    timeError: false
                })
            }
        }
        if (type == "endtime") {
            this.setState({
                endTime: e.target.value
            })
            if (this.state.startTime && e.target.value < this.state.startTime ) {
                this.setState({
                    timeError: true
                })
            }
                else {
                    this.setState({
                        timeError: false
                    })
                }
            
        }
        if (type == "startdate") {
            this.setState({
                startDate: e.target.value
            })
            if (this.state.endDate && e.target.value > this.state.endDate) {
                this.setState({
                    dateError: true
                })
            }
            else {
                this.setState({
                    dateError: false
                })
            }
        }
        if (type == "enddate") {
            this.setState({
                endDate: e.target.value
            })
            if (this.state.startDate && e.target.value < this.state.startDate) {
                this.setState({
                    dateError: true
                })
            }
            else {
                this.setState({
                    dateError: false
                })
            }
        }
    }

    async saveNotes(e) {//This onBlur function saves the text in the Notes textbox when the user loses focus on it
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            eventpk: this.props.eventpk,
            notetext: e.target.value
        }
        const response = await fetch('RecordSchedNote', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
    }

    checkIfOH(e) {//This function will see on selection of a day value whether Online or Hybrid was selected, and if it was the schedule needs to be exempted from time controls
        e.preventDefault();
        if (e.target.value == "ZA43" || e.target.value == "ZA41" || e.target.value == "ZA35") {
            this.setState({
                isOnlineHybrid: true
            })
        }
        else {
            this.setState({
                isOnlineHybrid: false
            })
        }
    }

    editNotes() {//This is the Notes textbox for when the user is allowed to edit the notes. 
        return (
            <div>
         <Label>Notes</Label>
                <Input type="textarea" id="notes" name="notes" defaultValue={this.state.notes.note}  onBlur={(e) => this.saveNotes(e)} /></div>
        );
    }

    fixedNotes() {//This is the Notes for when the user shouldn't be able to edit the notes
        return (
            <div>
                Notes:<br />
                {this.state.notes.note}
            </div>
        );
    }

    toggleErrorModal() {//This function is called when the error message's visibility needs to be switched
        this.setState({
            errorModalStatus: !this.state.errorModalStatus
        })
    }

    toggleLockModal() {
        this.setState({
            editLockModal: !this.state.editLockModal
            })
    }

    render() {
        let switchNotes = <div></div>
        let defaultStartDate = this.state.currentTermDates.startDate.substring(0, 4) + "-" + this.state.currentTermDates.startDate.substring(4, 6) + "-" + this.state.currentTermDates.startDate.substring(6)
        let defaultEndDate = this.state.currentTermDates.endDate.substring(0,4) + "-" + this.state.currentTermDates.endDate.substring(4,6) + "-" + this.state.currentTermDates.endDate.substring(6)
        if (this.props.eventstatus == "Editing" || this.state.activeDepartment == "Registrar") { switchNotes = this.editNotes(); }
        else { switchNotes = this.fixedNotes(); }
        if (this.state.currentTermDates.startDate == '19551105') { return null }//Here is a way we prevent rendering the component if its promises haven't fully resolved
        else {
            return (
                <div>
                    <Modal isOpen={this.state.editLockModal} toggle={this.toggleLockModal.bind(this)}>
                        <ModalHeader toggle={this.toggleLockModal.bind(this)}>ERROR: Semester Locked</ModalHeader>
                        <ModalBody>
                            <div classname="tooltipLinebreakCustom">This semester has been edit locked. Please wait for the Registrar to unlock it before performing this action.</div>
                        </ModalBody>
                        <ModalFooter></ModalFooter>
                    </Modal>
                    <Modal isOpen={this.state.errorModalStatus} toggle={this.toggleErrorModal.bind(this)}>
                        <ModalHeader toggle={this.toggleErrorModal.bind(this)}>ERROR: Faulty inputs</ModalHeader>
                        <ModalBody>
                            <div className="tooltipLinebreakCustom">{this.state.errorMessage}</div>
                            Please resolve the error and try again.
                        </ModalBody>
                        <ModalFooter>
                            <Button onClick={this.toggleErrorModal.bind(this)} color="primary">OK</Button>
                        </ModalFooter>
                    </Modal>
                    <div style={{ float: 'left' }}>
                        <Input type="select" name="action" id="action" value="DEFAULT" onChange={(e) => this.actionSelect(e, this.props.eventpk)} >
                            <option disabled value="DEFAULT">Actions...</option>
                            {this.state.actions.map(action => (
                                <option value={action.value}>{action.name}</option>
                            ))}
                        </Input>
                    </div> <br />&nbsp;<br />
                    {switchNotes}<br />
                    <div className="inlineCustom">
                        <Label hidden={this.props.eventstatus == "Editing" ? false : true}>Add Instructor</Label>
                        <Input type="select" name="instructor" id="instructor" onChange={this.addInstructor.bind(this)} invalid={this.state.addInstructorError} hidden={this.props.eventstatus == "Editing" ? false : true} value="DEFAULT" >
                            <option disabled={true} value="DEFAULT">Select an Instructor to Add</option>
                            {this.state.availableInstructors.filter(outer => !this.state.instructors.filter(inner => inner.pcid === outer.pcid).length)
                                .map(teachers => (
                                <option value={teachers.pcid}>{teachers.name}</option>
                            ))}
                            <FormFeedback>There was an error adding this instructor to the section</FormFeedback>
                        </Input>
                    </div>&nbsp;
                    {this.state.instructors.map(teachers => (
                        <div className="inlineCustom"><Badge>{teachers.name} <Button close hidden={this.props.eventstatus == "Editing" ? false : true} onClick={() => this.removeInstructor(teachers.pcid)} /></Badge></div>
                    ))}
                    <br /><div hidden={this.props.eventstatus == "Editing" ? false : true}>
                        <Form className="d-flex" onSubmit={this.addScheduleRecord.bind(this)} >
                            <FormGroup>
                                <Label>Days</Label>
                                <Input type="select" name="days" id="days" defaultValue="DEFAULT" invalid={this.state.dayError} onChange={(e) => this.checkIfOH(e)}>
                                    <option disabled={true} value="DEFAULT">Select Day...</option>
                                    {this.props.availableDays.map(day => (
                                        <option value={day.value}>{day.descrip}</option>))}
                                </Input>
                            </FormGroup>
                            &nbsp;
                            <FormGroup>
                                <Label>Start Time</Label>
                                <Input type="time" name="starttime" id="starttime" invalid={this.state.timeError} onBlur={(e) => this.checkTimeError(e, "starttime")} />

                            </FormGroup>
                            &nbsp;
                            <FormGroup>
                                <Label>End Time</Label>
                                <Input type="time" name="endtime" id="endtime" invalid={this.state.timeError} onBlur={(e) => this.checkTimeError(e, "endtime")} />
                            </FormGroup>
                            &nbsp;
                            <FormGroup>
                                <Label>Start Date</Label> 
                                <Input type="date" name="startdate" id="startdate" invalid={this.state.dateError} defaultValue={defaultStartDate} onBlur={(e) => this.checkTimeError(e, "startdate")} />
                            </FormGroup>
                            &nbsp;
                            <FormGroup>
                                <Label>End Date</Label>
                                <Input type="date" name="enddate" id="enddate" invalid={this.state.dateError} defaultValue={defaultEndDate} onBlur={(e) => this.checkTimeError(e, "enddate")} />
                            </FormGroup>
                            &nbsp;
                            <FormGroup>
                                <Label>Building/Room</Label>
                                <Input type="select" name="building1" id="building1" defaultValue="ANY" onChange={(e) => this.getRooms("1", e)}>
                                    <option value="ANY">No Preference</option>
                                    {this.props.availableBuildings.map(buildings => (
                                        <option value={buildings.code}>{buildings.name}</option>
                                    ))}
                                </Input>
                                <Label>Building/Room</Label>
                                <Input type="select" name="building2" id="building2" defaultValue="ANY" onChange={(e) => this.getRooms("2", e)}>
                                    <option value="ANY">No Preference</option>
                                    {this.props.availableBuildings.map(buildings => (
                                        <option value={buildings.code}>{buildings.name}</option>
                                    ))}
                                </Input>
                            </FormGroup>
                            <FormGroup>
                                <Label>First Choice</Label>
                                <Input type="select" name="room1" id="room1" value={this.state.room1select} onChange={(e) => this.setState({ room1select: e.target.value })}>
                                    {this.state.availableRooms1.map(room1 => (
                                        <option value={room1.code}>{room1.name}</option>
                                    ))}
                                </Input>
                                <Label>Second Choice</Label>
                                <Input type="select" name="room2" id="room2" value={this.state.room2select} onChange={(e) => this.setState({room2select: e.target.value}) }>
                                    {this.state.availableRooms2.map(room2 => (
                                        <option value={room2.code}>{room2.name}</option>
                                    ))}
                                </Input>
                            </FormGroup>
                            &nbsp;
                            <Button outline color="success" type="submit">Add Schedule</Button>
                        </Form></div>
                    <Table hover responsive striped>
                        <thead>
                            <tr>
                                <th>Days</th>
                                <th>Start Time</th>
                                <th>End Time</th>
                                <th>Start Date</th>
                                <th>End Date</th>
                                <th>Building/Room 1</th>
                                <th>Building/Room 2</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.scheduleRecords.map(record => (
                                <tr>
                                    <td>{record.days}</td>
                                    <td>{record.starttime}</td>
                                    <td>{record.endtime}</td>
                                    <td>{record.startdate}</td>
                                    <td>{record.enddate}</td>
                                    <td>{record.building}</td>
                                    <td>{record.room}</td>
                                    <td><Button color="danger" size="sm" outline hidden={this.props.eventstatus == "Editing" ? false : true} onClick={() => this.removeRecord(record.pk)}>Delete</Button></td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>
            );
        }
    }
}

const mapStateTo = state => ({
    reduxData: state
})

const mapDispatchTo = (dispatch) => {
    return {
        updateFetchTime: () => dispatch({ type: 'foundation/setFetchTime' })
    }
}

export default connect(mapStateTo, mapDispatchTo)(EventScheduler);